import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import React from 'react';
import { SelectionSet } from 'aws-amplify/api';
import { type Schema } from '../../../../../../amplify/data/resource';
import FileItem from './FileItem';

const selectionSet = [
  'id',
  'path',
  'date',
  'createdAt',
  'status',
  'error',
  'type',
  'xmlVersion',
  'executionDate',
  'workEnvironment',
  'fileNumber',
  'sequenceNumber',
  'senderCode',
  'senderIdentifierType',
  'senderId',
  'senderName',
  'senderContactFirstName',
  'senderContactLastName',
  'senderContactPhone',
  'senderContactEmail',
  'senderContactCellular',
  'recipientCode',
  'recipientIdentifierType',
  'recipientId',
  'recipientCreatorIdentifier',
  'userId',
  'user.*',
  'deposits.totalDepositAmount',
  'deposits.fundIdentifier',
  'deposits.employees.employeeId',
] as const;

// @ts-ignore
type File = SelectionSet<Schema['File']['type'], typeof selectionSet>;

interface Props {
  files: File[];
}

const FileList: React.FC<Props> = ({ files }) => {
  return (
    <Box sx={{ direction: 'rtl' }}>
      {files.length === 0 ? (
        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            marginTop: '20px',
            fontFamily: 'AlmoniDL',
          }}
        >
          למשתמש אין קבצים
        </Typography>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',

            overflowY: 'auto',
          }}
        >
          <Table
            sx={{
              backgroundColor: 'transparent',
              borderCollapse: 'separate',
              borderSpacing: '0 10px',
            }}
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: 'transparent' }}>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    תאריך העלאת קובץ
                  </Typography>
                </TableCell>
                <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  חודש שכר
                </Typography>
              </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    הוראות תשלום
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    שם חברה
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    מספר עובדים
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    סך הפקדה
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    סטטוס תשלום
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    סטטוס שליחת נתונים
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {files
                .slice()
                .sort(
                  (a, b) =>
                    new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
                )
                .map((file) => (
                  <FileItem key={file.id} file={file} />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default FileList;
